import fetch from 'isomorphic-fetch';
import {commonHeaders, commonErrorHandler} from './fetch.util';

export const IP_LIST_REQUEST = 'IP_LIST_REQUEST';
export const IP_LIST_RESPONSE = 'IP_LIST_RESPONSE';

export const IP_ITEMS_ADDED = 'IP_ITEMS_ADDED';
export const IP_ITEMS_REMOVED = 'IP_ITEMS_REMOVED';

export const IP_MEMO_CHANGED = 'IP_MEMO_CHANGED';

export function ipListRequest() {
  return {
    type: IP_LIST_REQUEST,
  };
}

export function ipListResponse(pcSlots) {
  return {
    type: IP_LIST_RESPONSE,
    pcSlots,
  };
}

export function ipItemsAdded(pcSlots) {
  return {
    type: IP_ITEMS_ADDED,
    pcSlots,
  };
}

export function ipItemsRemoved(pcSlots) {
  return {
    type: IP_ITEMS_REMOVED,
    pcSlots,
  };
}

export function ipMemoChanged(identificationValue, memo) {
  return {
    type: IP_MEMO_CHANGED,
    identificationValue,
    memo,
  };
}

export function fetchIpList() {
  return dispatch => {
    dispatch(ipListRequest());

    fetch(`${API_URL}/pc-slots/my-pc-slots`, {
      headers: commonHeaders(),
    })
      .then(response => response.json())
      .then(pcSlots => dispatch(ipListResponse(pcSlots)));
  };
}

export function saveAndFetchAllPcSlots(pcSlots) {
  return dispatch => {
    fetch(`${API_URL}/pc-slots/my-pc-slots`, {
      method: 'PUT',
      headers: commonHeaders(),
      body: JSON.stringify(pcSlots),
    })
      .then(response => commonErrorHandler(response))
      .then(() => {
        alert('IP 주소 등록/변경이 완료되었습니다.');
        dispatch(fetchIpList());
      })
      .catch(error => error.response.json())
      .then(errorJson => {
        if (errorJson) {
          alert(
            errorJson.message.replace('IP is already used by other PC Bang', 'IP가 다른 PC방에서 이미 사용중입니다.')
          );
        }
      });
  };
}
